<template>
  <div class="sale-row">
    <template v-if="item.trip_item_relation_type !== 'partial' || (item.trip_item_relation_type === 'partial' && item.is_first_partial_item)">
      <span :style="rowSpanStyle.checkbox" class="cell cell-sticky cell-sticky-first align-items-start">
        <b-checkbox
            v-model="item.selected_checkbox"
            :disabled="item.disabled_checkbox"
            @change="emitCheckboxChange"
        />
      </span>
      <div class="cell cell-sticky cell-sticky-second" :style="rowSpanStyle.number_index">
        <b-form-group label="No">
          {{ typeof displayNumber === "number" ? displayNumber : index + 1 }}
        </b-form-group>
      </div>
      <div class="cell cell-border-right" :style="rowSpanStyle.estimation">
        <b-form-group label="Produk">
          {{ productLabel }}
        </b-form-group>
      </div>
      <div class="cell cell-border-left" :style="rowSpanStyle.estimation">
        <b-form-group label="Size">
          {{ estimationSize }}
        </b-form-group>
      </div>
      <div class="cell cell-border-right" :style="rowSpanStyle.estimation">
        <b-form-group label="Biomassa">
          {{ estimationBiomassa }}
        </b-form-group>
      </div>
      <div class="cell cell-border-left" :style="rowSpanStyle.trip">
        <b-form-group label="Size">
          {{ notaArmadaSize }}
        </b-form-group>
      </div>
      <div class="cell cell-border-right" :style="rowSpanStyle.trip">
        <b-form-group label="Biomassa">
          {{ notaArmadaBiomassa }}
        </b-form-group>
      </div>
    </template>
    <validation-provider
      v-slot="{ validated, errors }"
      :name="lodash.upperFirst($t('purchase_orders.size'))"
      :vid="`sale_items-size-${index}`"
      class="cell cell-border-left"
      rules="required|min_value:1"
      :style="rowSpanStyle.sale"
    >
      <b-form-group
        :invalid-feedback="errors[0]"
        :state="errors[0] ? false : validated ? true : null"
        label="Size"
        label-class="required-indicator"
      >
        <b-input-group>
          <numeral-input
            v-model="item['size']"
            :name="`sale_items[${index}][size]`"
            :placeholder="lodash.upperFirst($t('purchase_orders.size'))"
            :state="errors[0] ? false : validated ? true : null"
            format="0,0.[00]"
            style="text-align: right"
          />
        </b-input-group>
      </b-form-group>
    </validation-provider>
    <validation-provider
      v-slot="{ validated, errors }"
      :name="lodash.upperFirst($t('purchase_orders.biomassa'))"
      :vid="`sale_items.${index}.quantity`"
      class="cell"
      rules="required|gt:0"
      :style="rowSpanStyle.sale"
    >
      <b-form-group
        :invalid-feedback="errors[0]"
        :state="errors[0] ? false : validated ? true : null"
        label="Biomassa (kg)"
        label-class="required-indicator"
      >
        <b-input-group>
          <numeral-input
            id="quantity"
            v-model="item['quantity']"
            :name="`sale_items[${index}][quantity]`"
            :placeholder="lodash.upperFirst(`Biomassa`)"
            :state="errors[0] ? false : validated ? true : null"
            format="0,0.[00]"
            lazy-formatter
            style="text-align: right"
          />
        </b-input-group>
      </b-form-group>
    </validation-provider>
    <validation-provider
      v-slot="{ validated, errors }"
      :name="lodash.startCase($t('purchase_orders.quality'))"
      :vid="`purchase_items.${validationKeyValue}.quality`"
      class="cell"
      rules="required"
      :style="rowSpanStyle.sale"
    >
      <b-form-group
        :invalid-feedback="errors[0]"
        :label="lodash.startCase($t('purchase_orders.quality'))"
        :state="errors[0] ? false : validated ? true : null"
        label-class="required-indicator"
      >
        <b-form-select
          id="quality"
          v-model="item['quality']"
          :name="`sale-items[${index}][quality]`"
          :options="qualityOptions"
          :placeholder="lodash.startCase($t('purchase_orders.quality'))"
          :state="errors[0] ? false : validated ? true : null"
        />
      </b-form-group>
    </validation-provider>
    <validation-provider
      v-slot="{ validated, errors }"
      :name="lodash.upperFirst('harga satuan bongkar')"
      :vid="`sale_items.${index}.unit_price`"
      class="cell"
      rules="required|gt:0"
      :style="rowSpanStyle.sale"
    >
      <b-form-group
        :invalid-feedback="errors[0]"
        :state="errors[0] ? false : validated ? true : null"
        label="Harga Satuan Bongkar"
        label-class="required-indicator"
      >
        <numeral-input
          id="total_unit_price"
          v-model="item['unit_price']"
          :name="`purchase_items[${index}][unit_price]`"
          :state="errors[0] ? false : validated ? true : null"
          format="$ 0,0.[00]"
          lazy-formatter
          style="text-align: right"
          placeholder="Harga Satuan Bongkar"
        />
      </b-form-group>
    </validation-provider>
    <div class="cell" :style="rowSpanStyle.sale">
      <b-form-group
        label="Jumlah Harga Bongkar"
        label-class="required-indicator"
      >
        <numeral-input
          id="total_unit_price"
          class="mb-1"
          :name="`sale_items[${index}][total_price]`"
          :value="totalPrice"
          disabled
          format="$ 0,0.[00]"
          lazy-formatter
          style="text-align: right"
        />
        <div v-if="showPartialButton" class="float-end">
          <b-button size="sm" variant="primary" @click="onPartialButton">
            <i class="fa fa-plus" />
          </b-button>
        </div>
        <div v-if="showRemovePartialButton" class="float-end me-2">
          <b-button size="sm" variant="outline-danger" @click="onRemovePartialButton">
            <i class="fa fa-trash" />
          </b-button>
        </div>
        <div v-if="showUngroupButton" class="float-end">
          <b-button size="sm" variant="outline-danger" @click="onUngroupButton">
            Ungroup
          </b-button>
        </div>
      </b-form-group>
    </div>
  </div>
</template>

<script>
import NumeralInput from "@/components/inputs/numeral.vue";
import {round} from "lodash";

export default {
  name: "SaleItemRow",
  components: {NumeralInput},
  props: {
    item: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    qualityOptions: {
      type: Array,
      required: true,
    },
    rowSpan: {
      type: Number,
      default: 1,
    },
    showPartialButton: {
      type: Boolean,
      default: false,
    },
    displayNumber: {
      type: Number,
      default: null,
    },
    showUngroupButton: {
      type: Boolean,
      default: false,
    },
    validationKey: {
      type: [String, Number],
      default: null,
    },
  },
  emits: ["partial-item", "ungroup-item", "change-checkbox", "remove-partial-item"],
  computed: {
    primaryTripItem() {
      return (this.item.trip_items && this.item.trip_items[0]) || {size: 0, quantity: 0};
    },
    rowSpanStyle() {
      if (this.item.trip_item_relation_type === 'merge') {
        let rowspan = this.item.trip_item_ids.length;
        return {
          checkbox : {gridRow: `span ${rowspan}`},
          number_index :  {gridRow: `span ${rowspan}`},
          estimation : null,
          trip : null,
          sale : {gridRow: `span ${rowspan}`},
        }
      } else if (this.item.trip_item_relation_type === 'partial') {
        let rowspan = this.item.partial_item_length * (2 - 1);
        return {
          checkbox : {gridRow: `span ${rowspan}`},
          number_index : {gridRow: `span ${rowspan}`},
          estimation : {gridRow: `span ${rowspan}`},
          trip : {gridRow: `span ${rowspan}`},
          sale : null,
        }
      }
      return {
        checkbox : null,
        number_index : null,
        estimation : null,
        trip : null,
        sale : null,
      }
    },
    estimationSize() {
      return round((Number(this.primaryTripItem.size) || 0) * 0.9, 2);
    },
    estimationBiomassa() {
      const value = round((Number(this.primaryTripItem.quantity) || 0) * 1.12, 2);
      return `${value} kg`;
    },
    notaArmadaSize() {
      return this.primaryTripItem.size || 0;
    },
    notaArmadaBiomassa() {
      const value = Number(this.primaryTripItem.quantity) || 0;
      return `${value} kg`;
    },
    productLabel() {
      return this.$t(`unloads.sale_items.products.${this.item.product_code}`);
    },
    validationKeyValue() {
      return this.validationKey != null ? this.validationKey : this.index;
    },
    totalPrice() {
      const quantity = Number(this.item.quantity) || 0;
      const unitPrice = Number(this.item.unit_price) || 0;
      return quantity * unitPrice;
    },
    showRemovePartialButton() {
      return this.item.trip_item_relation_type === "partial" && !this.item.is_first_partial_item;
    },
  },
  methods: {
    emitCheckboxChange() {
      this.$emit("change-checkbox", this.index);
    },
    onPartialButton() {
      this.$emit("partial-item", this.index);
    },
    onUngroupButton() {
      this.$emit("ungroup-item", this.index);
    },
    onRemovePartialButton() {
      this.$emit("remove-partial-item", this.index);
    },
  },
};
</script>
